<template>
    <div>
<!--body content start-->


<!--body content start-->

<div id="main-page" class="page-content">

<!--blog start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We Develop Digital Strategy</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>These guide Designing work</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We're Nominated To Agency</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
    </div>
  </div>
    <div class="row mt-5">
      <div class="col-md-4">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We Develop Digital Strategy</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>These guide Designing work</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We're Nominated To Agency</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
    </div>
    </div>
    <div class="row mt-5 text-center">
      <div class="col-sm-12">
        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li class="page-item"><a class="page-link" href="#"><i class="fas fa-arrow-right"></i></a>
            </li>
            <li class="page-item active"><a class="page-link" href="#">1</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">2</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">3</a>
            </li>
            <li class="page-item"><a class="page-link" href="#"><i class="fas fa-arrow-left"></i></a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</section>

<!--blog end-->

</div>

<!--body content end--> 

    </div>
</template>

<script>

export default {
    data: function () {
        return {
            name: 'blog grid 3'
        }
    },
};
</script>
